import { GET_WEBFORM_SUBMISSIONS } from 'store/constants'

export function getWebformSubmissions(values) {
    return {
        type: GET_WEBFORM_SUBMISSIONS,
        payload: values,
    }
}